import { Typography } from '@mui/material'
import { MemberMessage } from '../../../../../utils/classes/graphql'
import { MemberMessageTabContentWrapper } from '../../../components'

interface EmailsAndSMSTabContentProps {
  item: MemberMessage
}

export const EmailsAndSMSTabContent = ({
  item
}: EmailsAndSMSTabContentProps) => {
  const { viestinSisalto } = item

  return (
    <MemberMessageTabContentWrapper message={item}>
      <Typography sx={{ whiteSpace: 'pre-line' }}>{viestinSisalto}</Typography>
    </MemberMessageTabContentWrapper>
  )
}
